import { useState, useCallback, useEffect } from 'react';

import { faExpand } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DateTime } from 'luxon';

export function Overlay({ lastUpdated }: { lastUpdated: string }) {
  const [isFullscreen, setIsFullscreen] = useState(false);

  const displayFullscreen = useCallback(async () => {
    await document.body.requestFullscreen();
  }, []);

  useEffect(() => {
    const listener = () => {
      if (document.fullscreenElement) {
        setIsFullscreen(true);
      } else {
        setIsFullscreen(false);
      }
    };

    document.body.addEventListener('fullscreenchange', listener);

    return () => {
      document.body.removeEventListener('fullscreenchange', listener);
    };
  }, []);

  const [currentTime, setCurrentTime] = useState<DateTime | undefined>(
    DateTime.now(),
  );
  useEffect(() => {
    setInterval(() => {
      setCurrentTime(DateTime.now());
    }, 1000);
  }, []);

  return (
    <div className="absolute bottom-10 right-10 hidden items-center gap-4 text-white lg:flex">
      <p className="text-neutral-30">
        Last updated:{' '}
        {DateTime.fromISO(lastUpdated).toLocaleString(DateTime.DATETIME_SHORT)}
      </p>
      <p className="text-xl font-medium">
        {currentTime?.toFormat('HH:mm')}
        <span className="text-base font-normal">
          {' '}
          {currentTime?.toFormat('a')}
        </span>
      </p>
      {!isFullscreen && (
        <button
          className="flex h-11 w-11 items-center justify-center rounded-full bg-purple-50 px-4 py-2 text-neutral-80"
          type="button"
          onClick={displayFullscreen}
        >
          <FontAwesomeIcon icon={faExpand} title="Go fullscreen" />
        </button>
      )}
    </div>
  );
}
